import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useCallback, useEffect, useMemo, useState } from "react";

const MultipleSelectComponent = ({
  handleChange,
  label,
  path,
  required,
  schema,
  uischema,
  visible,
  enabled,
  data,
}) => {
  const options = useMemo(
    () =>
      schema?.items?.options ||
      schema?.options ||
      (Array.isArray(uischema?.options) ? uischema.options : []),
    [schema, uischema?.options]
  );

  const isSingleOptionDisabled =
    uischema?.options?.disableWhenSingle === true && options.length === 1;

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (isSingleOptionDisabled) {
      setSelected([options[0]]);
      const alreadySet =
        Array.isArray(data) && data.length === 1 && data[0] === options[0].id;
      if (!alreadySet) {
        handleChange(path, [options[0].id]);
      }
      return;
    }

    const hasData = Array.isArray(data) ? data.length > 0 : !!data;

    let newSelected;
    if (hasData && options.length > 0) {
      newSelected = options.filter((option) =>
        Array.isArray(data) ? data.includes(option.id) : data === option.id
      );
    } else {
      newSelected = [];
    }

    setSelected((prevSelected) => {
      const isEqual =
        Array.isArray(newSelected) && Array.isArray(prevSelected)
          ? newSelected.length === prevSelected.length &&
            newSelected.every((item, i) => item.id === prevSelected[i]?.id)
          : newSelected === prevSelected;
      return isEqual ? prevSelected : newSelected;
    });
  }, [
    data,
    handleChange,
    isSingleOptionDisabled,
    options,
    path,
    uischema?.selection,
  ]);

  const formatData = useCallback(
    (data) => (data && data.length > 0 ? data.map((item) => item.id) : []),
    []
  );

  const handleSelectValue = useCallback(
    (val) => {
      const normalizedValue = Array.isArray(val) ? val : val ? [val] : [];
      setSelected(normalizedValue);
      handleChange(path, formatData(normalizedValue));
    },
    [handleChange, path, formatData]
  );

  const isFieldDisabled = !enabled || uischema?.disabled || isSingleOptionDisabled;

  const selectionMode = isSingleOptionDisabled
    ? "single"
    : uischema?.selection === "single"
      ? "single"
      : "multiple";

  return visible ? (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        label={label}
        childList={options}
        selection={selectionMode}
        isRequired={required}
        disabled={isFieldDisabled}
        selectedValue={selected}
        placeholder={uischema?.placeholder}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};

export const MultipleSelectControl = withJsonFormsMultiEnumProps(
  MultipleSelectComponent
);
